import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import api from '../api/axiosInstance';
import { Link } from "react-router-dom";

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/blogs");
      setBlogs(res.data.slice(0, 3)); // sadece son 3 blog
    } catch (err) {
      console.error("Bloglar alınamadı:", err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <section id="blog" className="py-5" style={{ backgroundColor: "#fff" }}>
      <Container>
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
            Blog Yazıları
          </h2>
          <p className="text-muted lead">
            Güncel eczacılık trendleri ve majistral formülasyonlar hakkında bilimsel yazılar.
          </p>
        </motion.div>

        <Row className="g-4">
          {blogs.map((post, index) => (
            <Col md={4} key={post._id}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
              >
                <Card className="border-0 shadow-sm blog-card h-100">
                  <Card.Img
                    variant="top"
                    src={post.imageUrl || "/default-blog.jpg"}
                    alt={post.title}
                    style={{
                      height: "220px",
                      objectFit: "cover",
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                    }}
                  />

                  <Card.Body>
                    <Card.Title
                      style={{
                        color: "#2D8A7A",
                        fontWeight: "600",
                      }}
                    >
                      {post.title}
                    </Card.Title>

                    <Card.Text className="text-muted">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.content.substring(0, 130) + "...",
                        }}
                      />
                    </Card.Text>

                    {/* Devamını Oku */}
                    <Button
                      as={Link}
                      to={`/blog/${post._id}`}
                      variant="outline-primary"
                      className="mt-2 w-100"
                      style={{
                        color: "#2D8A7A",
                        borderColor: "#2D8A7A",
                      }}
                    >
                      Devamını Oku →
                    </Button>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>

        {/* Tüm Yazıları Gör Butonu */}
        <div className="text-center mt-5">
          <Button
            as={Link}
            to="/blogs"
            variant="primary"
            size="lg"
            style={{
              padding: "12px 30px",
              fontWeight: "600",
              borderRadius: "12px",
            }}
          >
            Tüm Yazıları Gör
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default BlogSection;
